
import TestResultModalComponent from "@/components/Modals/TestResultModal/TestResultModalComponent";
export default TestResultModalComponent;
